/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { useEffect } from "react";
import { API } from "../api/Api";
import { useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import ProgressMessage from "../components/ProgressMessage";
import { beautifyFilename } from "../utils/filenames";

const FileSharingDownloadPage = (): JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const filename = params.filename;
  const messageKey = "download";

  useEffect(() => {
    async function downloadFile(): Promise<void> {
      if (filename) {
        message.open({
          key: messageKey,
          content: <ProgressMessage progress={0} type={messageKey} />,
          duration: 0,
          icon: null,
        });
        const response = await API.downloadExchangeFile(
          filename,
          (progress) => {
            message.open({
              key: messageKey,
              content: (
                <ProgressMessage progress={progress} type={messageKey} />
              ),
              duration: 0,
              icon: null,
            });
          },
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", beautifyFilename(filename));
        document.body.appendChild(link);
        link.click();
        link.remove();
        message.success({
          key: messageKey,
          content: "Файл успешно загружен",
          duration: 2,
        });
      }
    }
    try {
      downloadFile();
    } catch (error) {
      console.error("Download file error", error);
      message.error({
        key: messageKey,
        content: "Ошибка при скачивании файла",
        duration: 2,
      });
    } finally {
      navigate("/admin/file-sharing");
    }
  }, []);

  return <></>;
};

export default FileSharingDownloadPage;
